export default __webpack_public_path__ + "static/media/closedEye.ea81b2be.png";